import maps from "@/assets/images/maps.png";
import { Terminal } from '@/models/terminal';
import { Card, Col, Descriptions, Empty, Image, Progress, Row, Tabs, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import TransactionLog from '../../audit-logs/components/transaction-log/transaction-log';
import RoundNumber from './display';
import './index.scss';
import { TerminalType } from "@/constants/app.enums";


interface TerminalDetailProps {
  terminal?: Terminal;
}

function AuditLogs(props: TerminalDetailProps) {
  const { t } = useTranslation();

  const logItems: TabsProps["items"] = [
    {
      key: "TransactionLog",
      label: (
        <>
          <Row className="h5-semiBold">{t("operation.transLog")}</Row>
          <Row className="status-validation"></Row>
        </>
      ),
      children: <TransactionLog terminalSerialNumber = {props.terminal?.terminalSerialNumber} />,
    },
    {
      key: "OperationLog",
      label: (
        <>
          <Row className="h5-semiBold">{t("operation.operationLog")}</Row>
          <Row className="status-validation"></Row>
        </>
      ),
      children: <Empty />,
    }
  ];

  return (
      <Row gutter={24} className="content-page">
        <Col span={24} className="white-tab">
        <Tabs
              defaultActiveKey="1"
              items={logItems}
              className="container"
              destroyInactiveTabPane={true}
            />
        </Col>
      </Row>
  );
}
export default AuditLogs;
